"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileInput = void 0;
var react_1 = __importStar(require("react"));
var react_2 = require("@chakra-ui/react");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var Icon_1 = require("../../Icon");
var useIsMobile_1 = require("../../DozukiHeader/hooks/useIsMobile");
var useSimpleDragDrop_1 = require("../useSimpleDragDrop");
function FileInput(_a) {
    var onChange = _a.onChange, mediaContext = _a.mediaContext, openInUploadView = _a.openInUploadView, boxProps = __rest(_a, ["onChange", "mediaContext", "openInUploadView"]);
    var _js = mediaContext._js;
    var isMobile = (0, useIsMobile_1.useIsMobile)();
    var inputRef = (0, react_1.useRef)(null);
    var _b = (0, useSimpleDragDrop_1.useSimpleDragDrop)(), dragActive = _b.dragActive, onHandleDrag = _b.onHandleDrag, onHandleDrop = _b.onHandleDrop;
    (0, react_1.useEffect)(function () {
        if (inputRef.current && openInUploadView && isMobile) {
            inputRef.current.click();
        }
    }, []);
    return (react_1.default.createElement(react_2.Flex, __assign({ direction: "column" }, boxProps),
        react_1.default.createElement(react_2.FormLabel, { htmlFor: "file-input", margin: "0", onDragEnter: onHandleDrag, "data-feature-id": "media_manager_import_browse", flex: 1 },
            react_1.default.createElement(react_2.Flex, { height: "100%", direction: "column", justifyContent: "center", alignItems: "center", bg: "white", p: "6", borderRadius: "md", cursor: "pointer", transition: "background-color 0.3s ease", _hover: { backgroundColor: 'blue.100' }, backgroundColor: dragActive ? 'blue.100' : 'white' },
                react_1.default.createElement(react_2.Flex, { gap: 1, mb: "6" },
                    react_1.default.createElement(Icon_1.Icon, { type: pro_solid_svg_icons_1.faFilePdf, fontSize: "45px", color: "orange.500", sx: { transform: 'rotate(-15deg)' }, mt: "2" }),
                    react_1.default.createElement(Icon_1.Icon, { type: pro_solid_svg_icons_1.faFileImage, fontSize: "54px", color: "blue.500" }),
                    react_1.default.createElement(Icon_1.Icon, { type: pro_solid_svg_icons_1.faFileVideo, fontSize: "45px", color: "green.500", sx: { transform: 'rotate(15deg)' }, mt: "2" })),
                react_1.default.createElement(react_2.Text, { fontSize: "lg" }, _js('Drag & drop here')),
                react_1.default.createElement(react_2.Text, { fontSize: "lg", color: "blue.500" }, _js('or browse for files'))),
            dragActive && (react_1.default.createElement(react_2.Box, { position: "absolute", right: "0", top: "0", bottom: "0", left: "0", onDragEnter: onHandleDrag, onDragLeave: onHandleDrag, onDragOver: onHandleDrag, onDrop: onHandleDrop }))),
        react_1.default.createElement(react_2.Input, { id: "file-input", type: "file", multiple: true, hidden: true, onChange: onChange, ref: inputRef })));
}
exports.FileInput = FileInput;
